'use client';

import { Fragment } from 'react';
import { Engage } from '@/partials/common/engage';
import { Faq } from '@/partials/common/faq';
import { useTranslation } from 'react-i18next';
import { toAbsoluteUrl } from '@/lib/helpers';

export function FaqContent() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 lg:gap-7.5">
      <div className="col-span-2">
        <Faq />
      </div>
      <div className="col-span-1">
        <div className="flex flex-col gap-5 lg:gap-7.5">
          <Engage
            title={t('faq.stillQuestions')}
            description={t('faq.stillQuestionsDesc')}
            image={
              <Fragment>
                <img
                  src={toAbsoluteUrl('/media/illustrations/31.svg')}
                  className="dark:hidden max-h-[150px]"
                  alt="Support illustration"
                />
                <img
                  src={toAbsoluteUrl('/media/illustrations/31-dark.svg')}
                  className="light:hidden max-h-[150px]"
                  alt="Support illustration"
                />
              </Fragment>
            }
            more={{
              title: t('faq.contactSupport'),
              url: '/contact',
            }}
          />
        </div>
      </div>
    </div>
  );
}
